import validate from "/home/runner/_work/mono/mono/out/node_modules/.pnpm/nuxt@4.6.1_@types+node@18.19.54_acorn@8.16.0_esbuild@0.24.0_oxlint@0.0.22_rolldown@1.2.13_tsx_l4usuacjwui4u7e5uxugvkycdm/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/home/runner/_work/mono/mono/out/apps/web/app/middleware/auth.global.ts";
import manifest_45route_45rule from "/home/runner/_work/mono/mono/out/node_modules/.pnpm/nuxt@4.6.1_@types+node@18.19.54_acorn@8.16.0_esbuild@0.24.0_oxlint@0.0.22_rolldown@1.2.13_tsx_l4usuacjwui4u7e5uxugvkycdm/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}